import { Col, Container, Row } from "react-bootstrap";
// import useMyProperties from "../../Hooks/UseMyProperties/UseMyPropertiesHook";
import timeService from "../../services/time/timeService";

// https://www.npmjs.com/package/react-virtualized

// https://www.npmjs.com/package/@tanstack/react-virtual

export default function MultiCalendarPage() {

    // const { myProperties, publicPropertyIdKeys } = useMyProperties();

    const startDate = timeService.createLuxonDate(new Date()).minus({ months: 1 }).startOf('day').toJSDate();
    const endDate = timeService.createLuxonDate(new Date()).plus({ months: 1 }).endOf('day').toJSDate();

    const dateHash = timeService.createDateHashObject(startDate, endDate);

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Multi Calendar</h1>
                </Col>
            </Row>


            <Row>
                <Col>

                    <div className="multi-calendar-container">
                        <div 
                        className="multi-calendar-header"
                        style={{
                            display: 'grid',
                            gridTemplateColumns: `repeat(${Object.keys(dateHash).length}, 50px)`,
                            gap: '1px',
                            overflowX: 'scroll',
                            paddingBottom: '10px',
                        }}
                        >
                            {/* list the days */}
                            {Object.keys(dateHash).map((dateKey) => {
                                const dateObj = dateHash[dateKey];
                                return (
                                    <div key={dateKey} className="multi-calendar-header-date">
                                        <div className="multi-calendar-header-date-day-of-week">
                                            {dateObj.dayOfWeek}
                                        </div>
                                        <div className="multi-calendar-header-month-name">
                                            {dateObj.monthName}
                                        </div>
                                        <div className="multi-calendar-header-date-day-of-month">
                                            {dateObj.dayOfMonth}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>

                        <div className="multi-calendar-body">
                            <div className="multi-calendar-properties">


                            </div>


                            <div className="multi-calendar-data">


                            </div>



                        </div>



                    </div>

                </Col>
            </Row>
        </Container>
    );
}